module.exports = __webpack_public_path__ + "img/shizi.69f35016.png";